import { useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Counts every click-to-call site-wide by listening for clicks on tel: links.
const CallTracker = () => {
  useEffect(() => {
    const handler = (e) => {
      const anchor = e.target.closest && e.target.closest('a[href^="tel:"]');
      if (anchor) {
        axios.post(`${API_URL}/api/calls/track`).catch(() => {});
      }
    };
    document.addEventListener('click', handler, true);
    return () => document.removeEventListener('click', handler, true);
  }, []);
  return null;
};

export default CallTracker;
